import wx from 'weixin-js-sdk'
import Vue from "vue";

const wxApi = {
  wxAxios() {
    let params = {
      Url: window.location.href.split('#')[0],
      Appid: "wxb5a883c5bf26e000",
    };
    window.axios
      .post("/api/user/wx/share", params)
      .then(res => {
        console.log(res);
        let DataList = JSON.parse(res.data.data.Ticket)
        if (res.data.code == 0) {
          // console.log(wx)
          wx.config({
            debug: lycamWeb.webHost().indexOf("testGkb") > -1 ? true : false,
            appId: lycamWeb.getAppid(), // 必填，公众号的唯一标识
            timestamp: DataList.timestamp, // 必填，生成签名的时间戳
            nonceStr: DataList.nonceStr, // 必填，生成签名的随机串
            signature: DataList.signature, // 必填，签名，见附录1
            jsApiList: [
              'updateAppMessageShareData',
              'updateTimelineShareData',
              'downloadImage'
            ], // 必填，需要使用的JS接口列表
            openTagList: ["wx-open-launch-weapp",'wx-open-subscribe']
          });

          Vue.prototype.$changeIsShare(true);
        }
      }).catch((e) => {
        console.log(e);
      });
  },
  /**,
   * [wxRegister 微信Api初始化]
   * @param {Function} callback [ready回调函数]
   */
  wxRegister(callback, option) {
    let IsPC = lycamWeb.IsPC()
    console.log(IsPC);
    wx.ready((res) => {
      // 判断微信环境
      function isWeixin() {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          return true;
        } else {
          return false;
        }
      };
      // 菜单隐藏
      if (IsPC && isWeixin()) {
        document.addEventListener(
          "WeixinJSBridgeReady",
          function onBridgeReady() {
            // 通过下面这个API隐藏右上角按钮
            WeixinJSBridge.call("hideOptionMenu");
          }
        );
        wx.hideMenuItems({
          menuList: [
            "menuItem:copyUrl",
            "menuItem:exposeArticle",
            "menuItem:share:weiboApp",
            "menuItem:favorite",
            "menuItem:share:facebook",
            "menuItem:share:QZone",
            "menuItem:editTag",
            "menuItem:delete",
            "menuItem:originPage",
            "menuItem:openWithQQBrowser",
            "menuItem:openWithSafari",
            "menuItem:share:email",
            "menuItem:share:brand",
            "menuItem:share:appMessage"
          ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        });
      } else {
        wx.hideMenuItems({
          menuList: [
            "menuItem:copyUrl",
            "menuItem:exposeArticle",
            "menuItem:share:weiboApp",
            "menuItem:favorite",
            "menuItem:share:facebook",
            "menuItem:share:QZone",
            "menuItem:editTag",
            "menuItem:delete",
            "menuItem:originPage",
            "menuItem:openWithQQBrowser",
            "menuItem:openWithSafari",
            "menuItem:share:email",
            "menuItem:share:brand",
          ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        });
      }

      // 如果需要定制ready回调方法
      // 判断是否含有code,去除code
      let link = window.location.href;
      let shareOption = {
        title: "考宝学涯", // 分享标题
        desc: "关注“考宝学涯”公众号，看招办主任宣讲，选对学校，选对专业！", // 分享描述
        link: link, // 分享链接，默认分享当前页，目前微信分享不支持https格式的链接
        imgUrl: "http://shouboke.tv/images/kaobaoxueya.png", // 分享图标
      }
      if (option && !IsPC) {
        shareOption = Object.assign(shareOption, option)
      }
      if (callback) {
        // 转义link
        if (shareOption.link.indexOf("#/") > -1) {
          let linkArray = shareOption.link.split("#/");
          shareOption.link = lycamWeb.webHost() + "?shareLink=" + encodeURIComponent(linkArray[1])
        }
        callback(shareOption);
      };
    });
    wx.error(function (res) {
      console.log(res)
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    });
  },
  ShareTimeline(option) {
    console.log("ShareTimeline");
    wx.updateTimelineShareData({
      title: option.title, // 分享标题
      desc: option.desc, // 分享描述
      link: option.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: option.imgUrl || 'http://shouboke.tv/images/kaobaoxueya.png', // 分享图标
      success() {
        if (option.success) {
          option.success();
        }
      },
      cancel() {
        if (option.cancel) {

          option.cancel();
        }
      },
      error() {
        if (option.error) {

          option.error();
        }
      }
    })
  },
  ShareAppMessage(option) {
    console.log("ShareAppMessage");
    wx.updateAppMessageShareData({
      title: option.title, // 分享标题
      desc: option.desc, // 分享描述
      link: option.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: option.imgUrl || 'http://shouboke.tv/images/kaobaoxueya.png', // 分享图标
      success() {
        if (option.success) {
          option.success();
        }
      },
      cancel() {
        if (option.cancel) {

          option.cancel();
        }
      },
      error() {
        if (option.error) {

          option.error();
        }
      }
    })
  }
}

export default wxApi



// WEBPACK FOOTER //
// ./src/utils/wxsdk.js